export const UserRoleConstants = {
    DESK_ADMIN: "Desk Admin",
    DIVISION_HEAD: "Division Head",
    FINANCE_ADMIN: "Finance Admin",
    FINANCE_EXECUTIVE: "Finance Executive",
    FINANCE_MANAGER: "Finance Manager",
    GENERAL_MANAGER: "General Manager",
    HR: "H R",
    HOD: "HOD",
    MANAGE_CUSTOMER: "Manage Customer",
    MANAGEMENT: "Management",
    TEAM_LEAD: "Team Lead",
    TEAM_MEMBER: "Team Member"
};

export const StatusConstants = {
    APPROVED: "Approved",
    PAID: "Paid",
    REJECTED: "Rejected",
    PENDING: "Pending",
    VALIDATED: "Validated",
    DRAFT: "Draft",

    PENDINGSUPERIOR: "Pending Superior",
    PENDINGFINANCEVALIDATION: "Pending Finance Validation",
    PENDINGPAYMENT: "Pending Payment",
    SUPERIORREJECTED: "Superior Rejected",
    FINANCEREJECTED: "Finance Rejected",
    PAYMENTREJECTED: "Payment Rejected"


}


export const StageConstants = {
    SUPERIOR: "Superior",
    FINANCE_EXECUTIVE: "Finance Executive",
    FINANCE_ADMIN: "Finance & Admin"
}

export const ClaimTypeGuidConstants = {
    GIFT_CLAIM: '2d8d7c80-c9ae-9736-b256-4d592e7b7887',
    OVERTIME_CLAIM: '37067b3d-1bf4-33a3-2b60-3ca40baf589a',
    MISCELLANIOUS_CLAIM: '84b3cee2-9f9d-ccb9-89a1-1e70cef19f86',
    TRAVEL_CLAIM: '58c59b56-289e-31a2-f708-138e81a9c823',
    PRINT_CLAIM: 'd9567482-033a-6d92-3246-f33043155746',
    ENTERTAINMENT_CLAIM: 'f3217ecc-19d7-903a-6c56-78fdbd7bbcf1'
}

export const ClaimMethodGuidConstants = {
    TOLL: '03048acb-037a-11e8-a50c-00155de7e742',
    PARKING: '0ebb7e5f-037a-11e8-a50c-00155de7e742',
    ACCOMMODATION: '0ebb7e5f-037a-11e8-a50c-ssh55de7e742',
    MEAL_ALLOWANCE: '0ebb7e5f-ssha-11e8-a50c-ssh55de7e742'
}

export const ClaimMethodNameConstants = {
    TOLL: 'Toll',
    PARKING: 'Parking',
    ACCOMMODATION: 'Accommodation',
    MEAL_ALLOWANCE: 'Meal Allowance'
}

export const ClaimPayTypeGuidConstants = {
    CASH: 'f74c3366-0437-51ec-91cc-d3fad23b061c',
    TOUCH_GO: 'cda1dcfb-170a-1f93-a6c6-6ba96879452f'
}


export const ProfileLevels = {
    ONE: '1',
    TWO: '2',
    THREE: '3',
    ZERO: '0',
    MINUSONE: '-1'
}
export const ClaimAmountConstants = {
    MIN_CLAIM_AMOUNT: 0,
    MAX_CLAIM_AMOUNT: 9999.99

}


// WEBPACK FOOTER //
// ./src/dbSettings/companySettings.ts